import React from 'react';
import { ContentArea } from '../../base/container/container';
import './about.css';

const About = () => {
  return(
    <ContentArea>
      <section className="about-section" id="about">
        <h2>About PORNO UND PIANO</h2>
        <h3>The Idea</h3>
        <p>
          Behind the pleasurable-sounding title,
          there is a unique combination of text and music,
          discourse and sensuality,
          as well as roleplay and societal analysis.
          The musical readings in Porno &amp; Piano
          intertwine pornography dialogue with theoretical texts and works of modern poets and thinkers
          to form literary collages –
          framed by and flavoured with new,
          experimental live music.
          The literary forays range from
            BDSM games,
            voyeurism
            and masturbation
            to basic theoretical texts
            and feminist power discourses.
          Look forward to extracts from classics in world literature and lyrical pieces from past eras,
          just as everyday notes and pearls of pop culture.
        </p>
        <h3>Background</h3>
        <p>
          Porno &amp; Piano is intended to break down barriers between entertainment,
          stimulation and pro-sex activism
          aiming to promote liberal discussions
          and make a sensuous-semantic contribution to unreserved interaction
          with sexuality and the questions that come with it.
          In its current form Porno &amp; Piano premiered in winter 2015.
          Previous readings took place in the former Kaufbar café in Friedrichshain,
          at the creative office e.V. and Herman Schulz café bar,
          the Greenhouse and Tatwerk Performative Forschung in Berlin,
          as well as the Fusion festival.
        </p>
        <h3>By and with</h3>
        <p>
          Five Berliners (by-choice)
          from the world of contemporary film, theatre, art and music
          who have a passion for reading, directing and seduction:
            Änne-Marthe Kühn,
            David Ford, 
            Ruben Giannotti,
            Martin Klaus
            and Thea Dymke.
        </p>
      </section>
    </ContentArea>
  );
}

export default About;
